"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalDocuments = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _Document = require("../../Document");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative'
}));
const LegalDocuments = props => {
  const {
    documentsConfig
  } = props;
  const [localDocuments, setLocalDocuments] = (0, _react.useState)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    setValue,
    watch,
    trigger
  } = (0, _reactHookForm.useFormContext)();
  const values = watch();
  const getDocumentLabel = localization => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    fontWeight: "bold",
    variant: "body1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      ...localization
    })
  });
  const updateIdentityCard = documentIds => {
    const documents = documentIds.map(id => ({
      documentId: id
    }));
    setLocalDocuments({
      ...documents,
      documentsCollection: documents
    });
    setValue('identityCard.documentsCollection', documents);
    trigger('identityCard.documentsCollection');
  };
  const updateAdditionalIdentityCard = documentIds => {
    const documents = documentIds.map(id => ({
      documentId: id
    }));
    setLocalDocuments({
      ...documents,
      documentsCollection: documents
    });
    setValue('additionalIdentityCard.documentsCollection', documents);
    trigger('additionalIdentityCard.documentsCollection');
  };
  const getDocumentIds = documents => {
    if (!documents) {
      return [];
    }
    // eslint-disable-next-line  @typescript-eslint/no-unnecessary-condition -- we need this condition
    return documents.documentsCollection?.map(d => d.documentId);
  };
  const renderIdentityCardDocument = () => {
    const config = documentsConfig?.identityCard;
    const isAvailable = config?.isAvailable ?? false;
    const isEditable = config?.isEditable ?? false;
    const idCardDocumentInfoText = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_IDCard_Text,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_IDCard_Text
    });
    if (!isAvailable) {
      return null;
    }
    const documentTypeId = config?.documentTypeId ?? 0;
    const correctDocuments = values.identityCard ?? localDocuments;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Document.Document, {
      isDeleteConfirmationRequired: true,
      documentTypeId: documentTypeId,
      documentLabel: getDocumentLabel({
        id: _models.TranslationKey.ThirdStep_IDCard_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_IDCard_Header
      }),
      documentInfoText: idCardDocumentInfoText,
      documentIds: getDocumentIds(correctDocuments),
      handleDocumentsChange: updateIdentityCard,
      config: config,
      isRequired: config?.validation?.isMandatory,
      editableDocument: isEditable,
      name: "identityCard.documentsCollection"
    });
  };
  const renderAdditionalIdentityCardDocument = () => {
    const config = documentsConfig?.additionalIdentityCard;
    const isAvailable = config?.isAvailable ?? false;
    const isEditable = config?.isEditable ?? false;
    const additionalDocumentInfoText = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_AdditionalIDCard_Text,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_AdditionalIDCard_Text
    });
    if (!isAvailable) {
      return null;
    }
    const documentTypeId = config?.documentTypeId ?? 0;
    const correctDocuments = values.additionalIdentityCard ?? localDocuments;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Document.Document, {
      isDeleteConfirmationRequired: true,
      documentTypeId: documentTypeId,
      documentLabel: getDocumentLabel({
        id: _models.TranslationKey.ThirdStep_AdditionalIDCard_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_AdditionalIDCard_Header
      }),
      documentInfoText: additionalDocumentInfoText,
      documentIds: getDocumentIds(correctDocuments),
      handleDocumentsChange: updateAdditionalIdentityCard,
      editableDocument: isEditable,
      isRequired: config?.validation?.isMandatory,
      name: "additionalIdentityCard.documentsCollection"
    });
  };
  const idCard = renderIdentityCardDocument();
  const additionalIdCard = renderAdditionalIdentityCardDocument();
  const documentsAvailableContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
    container: true,
    ...getTestIdProps('documents'),
    children: [idCard, additionalIdCard]
  });
  const documentsContent =
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing --- we want logical operator
  documentsConfig?.identityCard?.isAvailable || documentsConfig?.additionalIdentityCard?.isAvailable ? documentsAvailableContent : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RootContainer, {
    children: documentsContent
  });
};
exports.LegalDocuments = LegalDocuments;